import browser from './../../global/browser';
import InlineVideo from './InlineVideo';


export default class VideoBackground {

	constructor($videoContainer, $fallbackImage, $toggleButton) {

		this.$videoContainer = $videoContainer;
		this.$fallbackImage = $fallbackImage;
		this.$toggleButton = $toggleButton;

		if (browser.isIE(8)) return; // display fallback image instead

		this.video = new InlineVideo($videoContainer, {
        	loop: true
    	}).video;

    	if (!this.video) return;

    	// add public property to elem so we can check  
    	// if we're dealing with a background video in future
    	this.video.isBackgroundVideo = true;

    	// add event listeners
    	this.video.addEventListener('pause', this.pauseHandler.bind(this));
    	this.video.addEventListener('play', this.playHandler.bind(this));

    	if ($toggleButton) {
    		$toggleButton.on('click', this.toggleHandler.bind(this));
    	}
	}

	pauseHandler() {
		if (this.$toggleButton) {
			this.$toggleButton.addClass('is-paused');
		}
	}

	playHandler() {
		if (this.$toggleButton) {
			this.$toggleButton.removeClass('is-paused');
		}
		if (this.$fallbackImage) {
			this.$fallbackImage.remove();
		}
	}

	toggleHandler() {
		// if is playing
		if (
			!!(this.video.currentTime > 0 && !this.video.paused && !this.video.ended && this.video.readyState > 2)
		) {
		    this.video.pause();
		} else {
		    this.video.play();
		}
	}

}

